import { GroupBase } from "react-select";
import { AsyncProps } from "react-select/async";

import { ResponsiveProp, Width } from "../../../types";
import { AsyncDropdown } from "../../controls";
import FieldError from "../FieldError";
import FieldLabel from "../FieldLabel";
import FieldLayout from "../FieldLayout";

type Props<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
> = AsyncProps<Option, IsMulti, Group> & {
  label: React.ReactNode;
  name: string;
  showError?: boolean;
  error?: React.ReactNode;
  size?: "small" | "medium";
  dataNoTranslate?: boolean;
  menuWidth?: ResponsiveProp<Width>;
};

export default function FormAsyncDropdown<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: Props<Option, IsMulti, Group>) {
  const {
    name,
    label,
    error,
    showError = false,
    size = "medium",
    ...dropdownProps
  } = props;

  return (
    <FieldLayout showError={showError}>
      {{
        label: <FieldLabel htmlFor={name}>{label}</FieldLabel>,
        field: (
          <AsyncDropdown
            id={name}
            inputId={name}
            aria-labelledby={name}
            name={name}
            size={size}
            error={showError}
            {...dropdownProps}
          />
        ),
        error: <FieldError>{error}</FieldError>
      }}
    </FieldLayout>
  );
}
